import React from 'react';
import {
  IMessage,
  InputToolbar,
  InputToolbarProps,
} from 'react-native-gifted-chat';
import {Platform} from 'react-native';
import {ChatComposer} from './composer';
import {ChatSendButton} from './send';
import {IconButton, useTheme} from 'react-native-paper';
import {useAppSelector} from '../../../store/hooks';
// import { useFileSelectOptions } from '../../../hooks/useFileSelectOptions';
// import { useAppTheme } from '../../../../../utils/hooks/useAppTheme'
// import { useAppSelector } from '../../../../../store/hooks'

import {useFileSelectOptions} from '../../../hooks/useFileSelectOptions';
import {AttachmentDrawer} from './attachmentdrawer';
export function ChatInputToolbar({
  inputProps,
  chatId,
  isEmbed,
}: {
  inputProps: InputToolbarProps<IMessage>;
  chatId: string;
  isEmbed: boolean;
}) {
  const draftMessage = useAppSelector(
    state => state.chat.draftMessage[chatId],
  );
  const theme = useTheme();

  const fileSelectOptions = useFileSelectOptions(chatId, true);

  return (
    <>
      <InputToolbar
        {...inputProps}
        containerStyle={{
          borderTopWidth: 0,
          backgroundColor: theme.colors.surface,
          borderColor: 'transparent',
          minHeight: isEmbed ? 100 : 100,
          paddingTop: 20,
          height: 'auto',
          margin: 0,
          shadowColor: 'transparent',
          position: 'absolute',
          overflow: 'visible',
          bottom: 0,
        }}
        primaryStyle={{
          borderColor: 'transparent',
          shadowColor: 'transparent',
        }}
        renderComposer={composerProps => (
          <ChatComposer
            chatId={chatId}
            composerProps={{...composerProps}}
          />
        )}
        accessoryStyle={{height: 50, top: 10, position: 'absolute'}}
        // sendBut
        renderAccessory={composerProps => (
          <IconButton
            {...composerProps}
            icon={'plus'}
            iconColor={theme.colors.onSurface}
            size={28}
            onPress={fileSelectOptions.showDrawer}
          />
        )}
        renderSend={sendProps =>
          draftMessage ? (
            <ChatSendButton
              sendProps={{...sendProps}}
              chatId={chatId}
            />
          ) : null
        }
      />
      <AttachmentDrawer {...fileSelectOptions} />
    </>
  );
}
